import React from "react";
import { useAuth } from '../../auth';
import { Link, Redirect } from 'react-router-dom';

const roleToPath = {
  "adelaide-406": "/freemasonry/adelaide-406",
  "aurora-australis-431": "/freemasonry/aurora-australis-431",
  "avalon-1718": "/freemasonry/avalon-1718",
  "ouroboros-2175": "/freemasonry/ouroboros-2175",
  "sydney-404": "/freemasonry/sydney-404",
  "national": "/freemasonry/national",
  "secretaries": "/freemasonry/secretaries",
  "treasurers": "/freemasonry/treasurers",
  "ritual": "/freemasonry/ritual",
};

export function AdminsLayout() {
  const auth = useAuth();
  const session = auth.sessionV2 || auth.session || auth.user; // adjust as needed

  if (!session || !session.roles) {
    return <div style={{maxWidth: '800px', marginInline: 'auto'}}>Loading...</div>;
  }

  if (!Array.isArray(session.roles) || session.roles.length === 0) {
    // Option 1: Show access denied message
    return <div>You do not have access to any admin areas.</div>;
    // Option 2: Redirect to login or home
    // return <Redirect to="/admins/login" />;
  }

  return (
    <div className="container" style={{maxWidth: '800px', marginInline: 'auto'}}>
      <h1>Admin Dashboard</h1>
      <ul>
        {session.roles.map(role => {
          const path = roleToPath[role.toLowerCase()];
          return path ? (
            <li key={role}>
              <Link to={path}>{role.replace(/-/g, ' ').toUpperCase()}</Link>
            </li>
          ) : null;
        })}
      </ul>
    </div>
  );
}